export const WELCOME_ONBOARDING_OFFER_COLOR = "#8a2be2";

export const WELCOME_ONBOARDING_OFFER_BONUS_MULTIPLIER = 1;

export const FETCH_WELCOME_ONBOARDING_OFFER =
  "lwc/welcomeOnboardingOffer/fetch";

export const FETCH_WELCOME_ONBOARDING_OFFER_FULFILLED = `${FETCH_WELCOME_ONBOARDING_OFFER}/fulfilled`;
